<template>
  <Fornecedor />
</template>

<script>
import Fornecedor from "@/components/cadastros/Fornecedor";

export default {
  components: {
    Fornecedor
  },
  mounted() {
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaAreaDeFornecedor", this.$route.path);
  },
}
</script>

<style>

</style>
